import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const depositHistorySchema = z.object({
  /** Coin */
  coin: z.string(),
  /** Chain */
  chain: z.string(),
  /** Amount */
  amount: decimalSchema,
  /** Transaction ID */
  txID: z.string(),
  /** Deposit status */
  status: z.number().int(),
  /** Deposit target address */
  toAddress: z.string(),
  /** Tag of deposit target address */
  tag: z.string(),
  /** Deposit fee */
  depositFee: z
    .union([decimalSchema, z.literal('').transform(() => undefined)])
    .optional(),
  /** Last updated time (timestamp) */
  successAt: z.string(),
  /** Number of confirmation blocks */
  confirmations: decimalSchema,
  /** Transaction sequence number */
  txIndex: z.string(),
  /** Hash number on the chain */
  blockHash: z.string(),
  /** Deposit limit for the coin on this chain. "-1" means no limit */
  batchReleaseLimit: decimalSchema,
  /** Deposit type. 0: normal, 10: daily limit, 20: abnormal */
  depositType: z.string(),
  /** From address (shown only if unique on-chain) */
  fromAddress: z.string(),
  /** Tax ID for Bybit EU (Austria) users */
  taxDepositRecordsId: z.string(),
  /** Tax status: 0=No report, 1=Pending, 2=Completed */
  taxStatus: z.number().int(),
  /** Unique ID */
  id: z.string(),
})

export const responseSchema = z.object({
  retCode: z.number().int(),
  retMsg: z.string(),
  result: z.object({
    rows: z.array(depositHistorySchema),
    nextPageCursor: z.string().nullable(),
  }),
})
